export enum DividendSortBy {
  APPROVAL_DATE = 'approvalDate',
  NAME = 'name',
  PAYOUT_DATE = 'payoutDate',
}

export enum DividendSortOrder {
  ASC = 'asc',
  DESC = 'desc',
}

export enum DividendPeriodFilter {
  ALL_TIME = 'all-time',
  LAST_6_MONTHS = 'last-6-months',
  LAST_12_MONTHS = 'last-12-months',
}

export enum DividendPayoutType {
  PER_SHARE_CLASS = 'per-share-class',
  PER_STAKEHOLDER = 'per-stakeholder',
}

export enum DividendFrequency {
  ANNUALLY = 'annually',
  MONTHLY = 'monthly',
  QUARTERLY = 'quarterly',
  SEMI_ANNUALLY = 'semi-annually',
}

export enum DividendPayoutStatus {
  APPROVED = 'approved',
  PAID_OUT = 'paid-out',
  PENDING = 'pending',
}

export type DividendPayoutItem = {
  amountPerShare: null | number;
  dividendPayoutId: string;
  id: string;
  shareClassId: null | string;
  stakeholderId: null | string;
  totalAmount: null | number;
};

export type DividendPayoutStakeholderDocument = {
  filesLinks: string[];
  stakeholderId: string;
};

export type DividendShareClassHolder = {
  fullName: string;
  shareClassId: string;
  shares: number;
  stakeholderId: string;
};

export type DividendPayout = {
  additionalNotes: null | string;
  approvalDate: null | string;
  companyId: string;
  createdAt: string;
  filesLinks: string[];
  frequency: DividendFrequency;
  id: string;
  isLocked?: boolean;
  items: DividendPayoutItem[];
  name: string;
  payoutDate: null | string;
  periodIndex: null | number;
  stakeholderDocuments: DividendPayoutStakeholderDocument[];
  status: DividendPayoutStatus;
  type: DividendPayoutType;
  updatedAt: string;
  year: number;
};

export type DividendPayoutsResponse = {
  count: number;
  records: DividendPayout[];
  totalPages: number;
};

export type DividendStats = {
  lastPeriodDividends: number;
  payoutsCount: number;
  shareClassesCount: number;
  stakeholdersCount: number;
  totalPayout: number;
};

export type DividendDistributionByShareClass = {
  payoutsCount: number;
  shareClassId: string;
  shareClassName: string;
  stakeholdersCount: number;
  total: number;
};

export type DividendDistributionByStakeholder = {
  payoutsCount: number;
  shareClassesCount: number;
  stakeholderId: string;
  stakeholderName: string;
  total: number;
};

export type DividendDistributionOverTime = {
  frequency: DividendFrequency;
  periodIndex: null | number;
  total: number;
  year: number;
};

export type DividendDistribution = {
  byShareClass: DividendDistributionByShareClass[];
  byStakeholder: DividendDistributionByStakeholder[];
  overTime: DividendDistributionOverTime[];
};

export const dividendItemsToFetchMap = [10, 20, 50, 100];
